<template>
  <div class="user-container">
    <div class="nav-box">
      <div class="user-info">
        <img :src="user.logo"/>
        <span>{{ user.account }}</span>
      </div>
      <ul>
        <template v-for="(item, index) in navs">
          <li
            :class="curComponent == item.key ? 'active' : ''"
            :key="`${index}_${item.key}`"
            @click="changeComponent(item)"
          >
            {{ item.name }}
          </li>
        </template>
      </ul>
    </div>
    <div class="main-box">
      <div class="current-nav">
        <span>账号设置</span><i class="space-line"></i><span>{{ curNav }}</span>
      </div>
      <component v-bind:is="curComponent"></component>
    </div>
  </div>
</template>

<script>
const components = {}
const files = require.context('./components', false, /\.vue$/)
files.keys().reduce((component, componentPath) => {
  const componentName = componentPath.split('./')[1].replace(/\.vue/, '')
  const componentContent = files(componentPath).default
  component[componentName] = componentContent
  return component
}, components)
export default {
  name: 'Profile',
  components,
  data() {
    return {
      user: {
				name: this.$store.state.user.name,
        account: this.$store.state.user.account,
        logo: '',
      },
      curNav: '个人资料',
      curComponent: 'PersonalProfile',
      navs: [
        {
          name: '个人资料',
          key: 'PersonalProfile'
        },
        {
          name: '修改密码',
          key: 'ChangePassword'
        },
        {
          name: '第三方账号绑定',
          key: 'ThirdPartyAccount'
        }
      ]
    }
	},
	watch:{
		'$store.state.profile.logo'(newvalue){
			this.user.logo = newvalue;
		}
	},
	mounted(){
		 this.$nextTick(() => {
      this.user.logo = this.$store.state.profile.logo;
      if(location.hash.indexOf('?') > 0){
        location.hash = location.hash.split('?')[0]
      }
    });

    let { current } = this.queryParams(location.hash)
    if(current) {
      this.curComponent =  'ThirdPartyAccount'
    }
	},
  methods: {
		queryParams(hash){
			let params = {};
			let queryStr = hash.split('?')[1];
			if(queryStr) {
				let paramList = queryStr.split('&');
				paramList.forEach(param => {
					params[param.split('=')[0]] = param.split('=')[1]
				});
			}
			return params;
		},
    changeComponent(item) {
      const { key, name } = item
      this.curComponent = key
      this.curNav = name
    }
  }
}
</script>

<style lang="scss" scoped>
.user-container {
  width: 1160px;
  margin: 0 auto;
  display: flex;
  .nav-box {
    width: 200px;
    margin-right: 128px;
    .user-info {
      border-bottom: solid 1px #f0f0f2;
      height: 80px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-top: -20px;
      img {
        width: 50px;
			}
			span{
				font-size: 20px;
				margin-left: 16px;
				width: calc(100% - 66px);
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
				font-family: 'Source Han Sans SC';
				font-weight: bold;
				color: #434345;
				text-align: left;
			}
    }
    ul {
      li {
        height: 34px;
        line-height: 34px;
        margin: 15px 0;
        border-radius: 2px;
        text-align: left;
        padding-left: 18px;
        cursor: pointer;
        font-size: 14px;
        &.active {
          background: #514def1a;
          color: #514def;
        }
      }
    }
  }
  .main-box {
    // flex: 1;
    // flex-basis: auto;
    width: calc(100% - 328px);
    .current-nav {
      font-size: 20px;
      height: 20px;
      font-family: 'Source Han Sans SC';
      color: #434345;
      display: flex;
      align-items: center;
      margin: 18px 0 35px;
			span{
				height: 20px;
				line-height: 22px;
			}
      .space-line {
        margin: 0 12px;
        display: inline-block;
        width: 1px;
        height: 20px;
				background: #343438;
      }
      span:first-child {
        font-weight: bold;
      }
    }
  }
}
@media only screen and (max-width: 1366px) {
  .user-container {
  width: 85%;
  margin: 0 auto;
  .nav-box {
    width: 200px;
    margin-right: 88px;
    .user-info {
      border-bottom: solid 1px #f0f0f2;
      height: 80px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-top: -20px;
      img {
        width: 50px;
			}
			span{
				font-size: 20px;
				margin-left: 16px;
				width: calc(100% - 66px);
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
				font-family: 'Source Han Sans SC';
				font-weight: bold;
				color: #434345;
				text-align: left;
			}
    }
  }
  .main-box {
    width: calc(100% - 288px);
    .current-nav {
      font-size: 20px;
      height: 20px;
      font-family: 'Source Han Sans SC';
      color: #434345;
      display: flex;
      align-items: center;
      margin: 18px 0 35px;
			span{
				height: 20px;
				line-height: 22px;
			}
      .space-line {
        margin: 0 12px;
        display: inline-block;
        width: 1px;
        height: 20px;
				background: #343438;
      }
      span:first-child {
        font-weight: bold;
      }
    }
  }
}
}
</style>
